import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

const PlanSummaryBlock = ({
  children,
  className,
}: React.PropsWithChildren<{
  className?: string;
}>) => {
  return (
    <div
      className={twMerge(
        "flex-1 p-5 rounded-none gap-4 border-0.5 border-border flex flex-col",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default PlanSummaryBlock;
